var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"invoices tw-divide-y-2 tw-divide-ci-gray-150 tw-bg-ci-gray-50 tw-border-b-ci-gray-150 tw-border-b-2"},[_c('InvoiceRowHeader'),_vm._l((_vm.invoices),function(invoice){return _c('li',{key:invoice._id},[_c('InvoiceRow',{attrs:{"invoice":invoice,"transaction":_vm.transaction}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }